import { clearAllInputs, getAllFilterInputs } from "#utils/arrayFormatter";
import { GetAllObjectValue } from "#utils/objectFormatter";
import {
  FilterPillbox,
  MultiDropdownInputWithSearch,
} from "@validereinc/common-components";
import { differenceBy } from "es-toolkit/compat";
import React, { useEffect, useState } from "react";

const DEFAULT_FILTER_DROPDOWN = {
  facility: {
    label: "Facility",
    inputs: [],
    options: [],
  },
  facilityCode: {
    label: "Facility Code",
    inputs: [],
    options: [],
  },
};

function filterProductionReports(equipments, filters) {
  const { facility, facilityCode } = filters;

  const filteredInventories = equipments.filter((report) => {
    // if no intersection, it is not included in the filtered list
    if (
      facility?.length > 0 &&
      facility.every((name) => report.facility !== name)
    ) {
      return false;
    }

    if (
      facilityCode?.length > 0 &&
      facilityCode.every((code) => report.facility_code !== code)
    ) {
      return false;
    }

    return true;
  });

  return filteredInventories;
}

const EquipmentTableFilter = (equipments) => {
  const [filterDropdowns, setFilterDropdowns] = useState({
    ...DEFAULT_FILTER_DROPDOWN,
  });

  useEffect(() => {
    if (equipments.length > 0) {
      const { facility, facilityCode } = filterDropdowns;

      facility.options = GetAllObjectValue(equipments, "facility");
      facilityCode.options = GetAllObjectValue(equipments, "facility_code");

      setFilterDropdowns((filterDropdowns) => ({
        ...filterDropdowns,
        facility,
        facilityCode,
      }));
    }
  }, [equipments]);

  const onDropdownSelect = (selectedValue, key) => {
    const filterDropdown = { ...filterDropdowns[key] };
    filterDropdown.inputs = selectedValue;

    setFilterDropdowns({ ...filterDropdowns, [key]: filterDropdown });
  };

  const clearAllFilters = () => {
    setFilterDropdowns(clearAllInputs(filterDropdowns));
  };

  const onClearFilterClick = (filterObject) => {
    if (filterObject) {
      const { filterKey } = filterObject;
      const updatedFilterDropdown = { ...filterDropdowns[filterKey] };

      updatedFilterDropdown.inputs = differenceBy(
        updatedFilterDropdown.inputs,
        [filterObject],
        "id"
      );

      setFilterDropdowns({
        ...filterDropdowns,
        [filterKey]: updatedFilterDropdown,
      });
    } else {
      clearAllFilters();
    }
  };

  const filterRow = (
    <div className="filterRow">
      {Object.keys(filterDropdowns).map((key) => {
        const { label, labelKey, options, inputs } = filterDropdowns[key];

        return (
          <MultiDropdownInputWithSearch
            key={key}
            label={label}
            labelKey={labelKey ? labelKey : null}
            dropdownKey={key}
            value={inputs}
            options={options}
            onChange={onDropdownSelect}
          />
        );
      })}
    </div>
  );

  const filterInputs = getAllFilterInputs(filterDropdowns);

  const filteredProductionReports = filterProductionReports(
    equipments,
    filterInputs
  );

  const filterPillbox = (
    <FilterPillbox
      filterBy={filterInputs}
      onClearFilterClick={onClearFilterClick}
    />
  );

  return [filterRow, filterPillbox, filteredProductionReports];
};

export default EquipmentTableFilter;
